// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 60px;
  background: var(--primary-red);
  z-index: 1000;
}


.navbar-inner {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding-left: 270px;   /* sidebar width + gap */
  padding-right: 25px;

  transition: padding-left 0.3s ease;
  color: white;
}

.navbar-inner.full {
  padding-left: 25px;    /* when sidebar closed */
}


.hamburger {
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    color: white;
}
.user-info {
    display: flex;
    align-items: center;
    gap: 10px;
}
.nav-right {
  display: flex;
  align-items: center;
  gap: 20px;
}

.notification {
  position: relative;
  cursor: pointer;
}

.bell-icon {
  font-size: 25px;
  color: white;
}

.notification-count {
  position: absolute;
  top: -6px;
  right: -8px;
  background: rgb(0, 0, 0);
  color: white;
  font-size: 11px;
  padding: 2px 6px;
  border-radius: 50%;
  font-weight: bold;
}
.notification {
  position: relative;
}

.notification-box {
  position: absolute;
  top: 30px;
  right: 0;
  width: 320px;
  background: #fff;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  border-radius: 6px;
  z-index: 100;
}

.notification-header {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  border-bottom: 1px solid #eee;
  color: black;
}

.notification-header button {
  background: green;
  color: white;
  border: none;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
}

.notification-item {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  border-bottom: 1px solid #f1f1f1;
  color: black;
}

.notification-item p {
  margin: 0;
  font-size: 13px;
  color: #555;
}

.notification-item button {
  background: #0d6efd;
  color: white;
  border: none;
  font-size: 12px;
  padding: 4px 6px;
  border-radius: 4px;
  cursor: pointer;
}

.empty {
  padding: 10px;
  text-align: center;
  color: #777;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Navbar.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,8BAA8B;EAC9B,aAAa;AACf;;;AAGA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;;EAE9B,mBAAmB,IAAI,wBAAwB;EAC/C,mBAAmB;;EAEnB,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,kBAAkB,KAAK,wBAAwB;AACjD;;;AAGA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,YAAY;AAChB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,wBAAwB;EACxB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,uCAAuC;EACvC,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb","sourcesContent":[".navbar {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  height: 60px;\r\n  background: var(--primary-red);\r\n  z-index: 1000;\r\n}\r\n\r\n\r\n.navbar-inner {\r\n  height: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n\r\n  padding-left: 270px;   /* sidebar width + gap */\r\n  padding-right: 25px;\r\n\r\n  transition: padding-left 0.3s ease;\r\n  color: white;\r\n}\r\n\r\n.navbar-inner.full {\r\n  padding-left: 25px;    /* when sidebar closed */\r\n}\r\n\r\n\r\n.hamburger {\r\n    background: none;\r\n    border: none;\r\n    font-size: 24px;\r\n    cursor: pointer;\r\n    color: white;\r\n}\r\n.user-info {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n}\r\n.nav-right {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 20px;\r\n}\r\n\r\n.notification {\r\n  position: relative;\r\n  cursor: pointer;\r\n}\r\n\r\n.bell-icon {\r\n  font-size: 25px;\r\n  color: white;\r\n}\r\n\r\n.notification-count {\r\n  position: absolute;\r\n  top: -6px;\r\n  right: -8px;\r\n  background: rgb(0, 0, 0);\r\n  color: white;\r\n  font-size: 11px;\r\n  padding: 2px 6px;\r\n  border-radius: 50%;\r\n  font-weight: bold;\r\n}\r\n.notification {\r\n  position: relative;\r\n}\r\n\r\n.notification-box {\r\n  position: absolute;\r\n  top: 30px;\r\n  right: 0;\r\n  width: 320px;\r\n  background: #fff;\r\n  box-shadow: 0 4px 12px rgba(0,0,0,0.15);\r\n  border-radius: 6px;\r\n  z-index: 100;\r\n}\r\n\r\n.notification-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  padding: 10px;\r\n  border-bottom: 1px solid #eee;\r\n  color: black;\r\n}\r\n\r\n.notification-header button {\r\n  background: green;\r\n  color: white;\r\n  border: none;\r\n  padding: 4px 8px;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n}\r\n\r\n.notification-item {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  padding: 10px;\r\n  border-bottom: 1px solid #f1f1f1;\r\n  color: black;\r\n}\r\n\r\n.notification-item p {\r\n  margin: 0;\r\n  font-size: 13px;\r\n  color: #555;\r\n}\r\n\r\n.notification-item button {\r\n  background: #0d6efd;\r\n  color: white;\r\n  border: none;\r\n  font-size: 12px;\r\n  padding: 4px 6px;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n}\r\n\r\n.empty {\r\n  padding: 10px;\r\n  text-align: center;\r\n  color: #777;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
